/**
 * File hand-off for the pitch PDF (PV19, SE-8361) — web only in v1, as the
 * table export. The hook decides whether the platform can hand a file off;
 * this writer assumes a browser.
 * @module features/scouting/utils/watchlistPitchPdfFile
 */

import {
  type PitchPdfMeta,
  type PitchPdfModel,
  renderWatchlistPitchPdf,
} from "@/features/scouting/utils/watchlistPitchPdf";

/**
 * Renders the model and offers it as a PDF download.
 * @param model - From `toPitchPdfModel`
 * @param meta - Footer inputs
 * @param filename - The suggested filename
 * @param isCurrent - Whether the asking run is still current; checked before
 * and after the render (the jspdf import awaits) so a retired run writes nothing
 */
export const writePitchPdfFile = async (
  model: PitchPdfModel,
  meta: PitchPdfMeta,
  filename: string,
  isCurrent: () => boolean = () => true
): Promise<void> => {
  if (!isCurrent()) return;
  const pdf = await renderWatchlistPitchPdf(model, meta);
  if (!isCurrent()) return;
  pdf.save(filename);
};
